(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/aria-utils/assets/javascripts/get-aria-label-for-event.js') >= 0) return;  svs.modules.push('/components/pool-betting/aria-utils/assets/javascripts/get-aria-label-for-event.js');
"use strict";


const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const getAriaLabelForEvent = _ref => {
  let eventTypeId = _ref.eventTypeId,
    homeParticipant = _ref.homeParticipant,
    awayParticipant = _ref.awayParticipant;
  const isHead2Head = eventTypeId === EventTypeId.HEAD_TO_HEAD;
  const isTotalNumberOfGoals = eventTypeId === EventTypeId.AMOUNT;
  const isWinner = eventTypeId === EventTypeId.EVENT_1_2;
  const isOverUnder = eventTypeId === EventTypeId.OVER_UNDER;
  if (isTotalNumberOfGoals) {
    return "Vad blir det totala antalet m\xE5l i matchen mellan ".concat(homeParticipant === null || homeParticipant === void 0 ? void 0 : homeParticipant.name, " och ").concat(awayParticipant === null || awayParticipant === void 0 ? void 0 : awayParticipant.name);
  }
  if (isWinner) {
    return "Vem vinner ".concat(homeParticipant === null || homeParticipant === void 0 ? void 0 : homeParticipant.name, " eller ").concat(awayParticipant === null || awayParticipant === void 0 ? void 0 : awayParticipant.name);
  }
  if (isOverUnder) {
    return "\xD6ver antal m\xE5l/po\xE4ng ".concat(homeParticipant === null || homeParticipant === void 0 ? void 0 : homeParticipant.name, " eller under antal m\xE5l/po\xE4ng ").concat(awayParticipant === null || awayParticipant === void 0 ? void 0 : awayParticipant.name);
  }
  if (isHead2Head) {
    return "Vem g\xF6r flest m\xE5l? ".concat(homeParticipant === null || homeParticipant === void 0 ? void 0 : homeParticipant.h2HName, " mot ").concat(awayParticipant === null || awayParticipant === void 0 ? void 0 : awayParticipant.h2HName, " ");
  }
  return "".concat(homeParticipant === null || homeParticipant === void 0 ? void 0 : homeParticipant.name, " - ").concat(awayParticipant === null || awayParticipant === void 0 ? void 0 : awayParticipant.name, " ");
};
setGlobal('svs.components.poolBetting.ariaUtils.getAriaLabelForEvent', getAriaLabelForEvent);

 })(window);